import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SESSION_ID } from 'src/app/constants/authentication.constants';
import { CaseModel } from 'src/app/models/case.model';
import { WindowService } from 'src/app/services/window.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'tx-new-document',
  templateUrl: './new-document.component.html',
  styleUrls: ['./new-document.component.scss'],
})
export class NewDocumentComponent implements OnInit {
  public submitUrl: string;
  public isClientDocument: boolean;
  public sessionId = SESSION_ID;
  @ViewChild('openInNewTabForm') openInNewTabForm!: ElementRef;
  @Output() newDocumentSelected: EventEmitter<CaseModel | null> = new EventEmitter();

  constructor(private windowService : WindowService) {
    this.isClientDocument = false;
    this.submitUrl = environment.endpoints.apiUrl + '/document/newdocument';
  }

  ngOnInit(): void {}

  onNewClientDocumentClicked() {
    this.isClientDocument = true;
  }

  onNewGeneralDocumentClicked() {
    this.isClientDocument = false;
    this.setFormField('ctcId', '');
    this.setFormField('casId', '');
    this.setFormField(this.sessionId, this.windowService.getSessionIdFromWindow() ?? '');
    this.openInNewTabForm.nativeElement.submit();
    this.newDocumentSelected.emit(null);
  }

  onCaseSelected(c: CaseModel) {
    this.setFormField('ctcId', c.ctcId);
    this.setFormField('casId', c.casID);
    this.setFormField(this.sessionId, this.windowService.getSessionIdFromWindow() ?? '');
    this.openInNewTabForm.nativeElement.submit();
    this.newDocumentSelected.emit(null);
  }

  private setFormField(fieldName: string, value: string) {
    const formField = document.getElementById(fieldName) as HTMLInputElement;
    if (formField) {
      formField.value = value ?? '';
    }
  }
}
